import React, {useState} from 'react';
import {Link} from "react-router-dom";
import {getAuth, sendPasswordResetEmail} from "firebase/auth";
import app from '../../utils/firebase';
import logo from '../../assets/mvp-logo-black.svg';
import ball1 from '../../assets/home/ball1.png';
import ball2 from '../../assets/home/ball2.png';
import ball3 from '../../assets/home/ball3.png';
import FloatingImage from "../../components/FloatingImage";
import Button from "../../components/Button";
import * as Routes from "../../utils/routes.js";

import './ForgotPassword.scss';
import LoadingPanel from "../../components/LoadingPanel";

const auth = getAuth(app);

const ForgotPassword = props => {
	const [loading, setLoading] = useState(false);
	const [emailSent, setEmailSent] = useState(false);
	const [email, setEmail] = useState("");
	const [error, setError] = useState("");
	const [success, setSuccess] = useState("");

	const sendRequest = async () => {
		setError("");

		if(email.length < 5 || email.indexOf("@") < 0) {
			setError("Please enter a valid email address.");
		}
		else {
			setLoading(true);
			await sendPasswordResetEmail(auth, email)
				.then(res => {
				})
				.catch(e => {
					console.log(e);
				})
				.finally(() => {
					setEmailSent(true);
					setLoading(false);
				})
		}
	};

	if(emailSent) {
		return (
			<div className="forgot-container">
				<img src={logo} alt="" className="forgot-logo" />

				<div style={{position: 'absolute', bottom: '100px', left: '20vw'}}>
					<FloatingImage src={ball1} uid="ball1" animationDuration={2500} fromValue={0} toValue={-150} />
				</div>

				<div style={{position: 'absolute', bottom: '100px', left: '30vw'}}>
					<FloatingImage src={ball2} uid="ball2" animationDuration={1500} fromValue={-40} toValue={-120} />
				</div>

				<div style={{position: 'absolute', bottom: '100px', right: '20vw'}}>
					<FloatingImage src={ball3} uid="ball3" animationDuration={5000} fromValue={0} toValue={-230} />
				</div>

				<div className="forgot-box-wrapper">
					<div className="forgot-box">
						<div/>
						<div style={{fontSize: '19px', color: '#142A31', fontWeight: 700}}>Forgot your password</div>

						<div className="forgot-description">
							Thanks for submitting your email. If it matches an account, you'll receive a password reset email shortly.
							<br/><br/>
							Check your inbox, including spam, and follow the instructions.
							<br/><br/><br/><br/>
						</div>

						<Link to={Routes.SIGN_IN} className="forgot-password-link">&lt; Back</Link>
					</div>
				</div>
				<div className="email-row">Email us at <a href="mailto:support@connact.cloud"><b>support@connact.cloud</b></a> for any issues</div>
			</div>
		)
	}

	return (
		<div className="forgot-container">

			{ loading && <LoadingPanel /> }

			<img src={logo} alt="" className="forgot-logo" />

			<div style={{position: 'absolute', bottom: '100px', left: '20vw'}}>
				<FloatingImage src={ball1} uid="ball1" animationDuration={2500} fromValue={0} toValue={-150} />
			</div>

			<div style={{position: 'absolute', bottom: '100px', left: '30vw'}}>
				<FloatingImage src={ball2} uid="ball2" animationDuration={1500} fromValue={-40} toValue={-120} />
			</div>

			<div style={{position: 'absolute', bottom: '100px', right: '20vw'}}>
				<FloatingImage src={ball3} uid="ball3" animationDuration={5000} fromValue={0} toValue={-230} />
			</div>

			<form>
				<div className="forgot-box-wrapper">
					<div className="forgot-box">
						<div/>
						<div style={{fontSize: '19px', color: '#142A31', fontWeight: 700}}>Forgot your password</div>

						<div className="forgot-description">
							Please enter the email address you use to sign in
						</div>

						<br/>

						<input type="text" autoComplete="username" value={email} onChange={e => setEmail(e.target.value)} className="forgot-input" placeholder="Email" />

						{ success.length === 0 && <div className="forgot-error">{error}&nbsp;</div> }
						{ success.length > 0 && <div className="forgot-success">{success}</div> }

						<Button padding="20px" onClick={sendRequest}>Request password reset</Button>

						<Link to={Routes.SIGN_IN} className="forgot-password-link">&lt; Back</Link>

					</div>
				</div>
			</form>

			<div className="email-row">Email us at <a href="mailto:support@connact.cloud"><b>support@connact.cloud</b></a> for any issues</div>
		</div>
	)
};

export default ForgotPassword;
